// 设置order页面目的
export const ORDER__SET_AIM = 'ORDER__SET_AIM';
// 设置当前orderInfo
export const ORDER__SET_ORDER_INFO = 'ORDER__SET_ORDER_INFO';
